import { defineComponent, ref, watch, nextTick, computed, createElementBlock, createCommentVNode, openBlock, normalizeClass, createElementVNode, createBlock, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es120.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es122.js';
import _sfc_main$4 from './basler-components.es118.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es123.js';
/* empty css                        */
import _sfc_main$5 from './basler-components.es114.js';
/* empty css                        */
import _sfc_main$6 from './basler-components.es116.js';
/* empty css                        */

const _hoisted_1 = { key: 6 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Media",
  props: {
    media: { default: null },
    cols: { default: () => [] },
    lazyload: { type: Boolean, default: true }
  },
  emits: ["iframeLoaded", "animationLoaded"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const mediaContainer = ref(null);
    watch(
      () => props.media,
      async (newVal) => {
        await nextTick();
        if (newVal && mediaContainer.value) {
          const iframe = mediaContainer.value?.querySelector("iframe");
          if (iframe) {
            iframe.addEventListener("load", onIframeLoad, { once: true });
          }
        }
      },
      { immediate: true }
    );
    const getMediaImage = computed(() => {
      if (props.media?.content) {
        return props.media.content;
      }
      return {};
    });
    const getMediaVideo = computed(() => {
      if (props.media?.content) {
        return props.media.content;
      }
      return {};
    });
    const getMediaYoutube = computed(() => {
      if (props.media?.content) {
        return props.media.content;
      }
      return {};
    });
    const getMediaIframe = computed(() => {
      if (props.media?.content) {
        return props.media.content;
      }
      return {};
    });
    const getMediaAnimation = computed(() => {
      if (props.media?.content) {
        return props.media.content;
      }
      return {};
    });
    const getMediaChart = computed(() => {
      if (props.media?.content) {
        return props.media.content;
      }
      return {};
    });
    const getCaption = computed(() => {
      if (props.media?.caption) {
        return props.media.caption;
      }
      return "";
    });
    const styleType = computed(() => {
      if (props.media?.styleType) {
        return props.media.styleType;
      }
      return "default";
    });
    const onIframeLoad = () => {
      emit("iframeLoaded");
    };
    const onAnimationLoad = () => {
      emit("animationLoaded");
    };
    return (_ctx, _cache) => {
      return _ctx.media?.content ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["media", `media--${styleType.value}`])
      }, [
        createElementVNode("figure", {
          ref_key: "mediaContainer",
          ref: mediaContainer,
          class: normalizeClass(["media__inner"])
        }, [
          _ctx.media?.type === "image" ? (openBlock(), createBlock(_sfc_main$1, {
            key: 0,
            media: getMediaImage.value,
            cols: _ctx.cols,
            lazyload: _ctx.lazyload
          }, null, 8, ["media", "cols", "lazyload"])) : _ctx.media?.type === "video" ? (openBlock(), createBlock(_sfc_main$2, {
            key: 1,
            media: getMediaVideo.value
          }, null, 8, ["media"])) : _ctx.media?.type === "youtube" ? (openBlock(), createBlock(_sfc_main$3, {
            key: 2,
            media: getMediaYoutube.value
          }, null, 8, ["media"])) : _ctx.media?.type === "iframe" ? (openBlock(), createBlock(_sfc_main$4, {
            key: 3,
            media: getMediaIframe.value
          }, null, 8, ["media"])) : _ctx.media?.type === "animation" ? (openBlock(), createBlock(_sfc_main$5, {
            key: 4,
            media: getMediaAnimation.value,
            onAnimationLoaded: onAnimationLoad
          }, null, 8, ["media"])) : _ctx.media?.type === "chart" ? (openBlock(), createBlock(_sfc_main$6, {
            key: 5,
            media: getMediaChart.value
          }, null, 8, ["media"])) : createCommentVNode("", true),
          _ctx.media?.caption ? (openBlock(), createElementBlock("figcaption", _hoisted_1, toDisplayString(getCaption.value), 1)) : createCommentVNode("", true)
        ], 512)
      ], 2)) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
